
import { Injectable } from '@angular/core';
import { selectAllUsers, selectUsersByCompanyId, selectUsersById } from './store/reducers';
import { UUID } from 'angular2-uuid';
import * as UserActions from './store/actions/users.actions';
import { Observable, of } from 'rxjs';
import { catchError, map, finalize } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { User } from '../models/user.model';



@Injectable({
  providedIn: 'root'
})
export class UsersService {
  messages$: any;
  private url = '';
  private endpoint = 'advert-manifests';

  constructor(
    private db: AngularFirestore,
    private store: Store<any>
  ) { }

  getUsers$(): Observable<any> {

    const usersCollection = this.db.collection<User>('users', ref => ref
      // .where('id', '==', userId)
    );

    return usersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  getUsersById$(userId: string): Observable<any> {

    const usersCollection = this.db.collection<User>('users', ref => ref
      .where('uid', '==', userId)
    );

    return usersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  getUsersByCompanyId(companyId: string) {
    this.store.dispatch(new UserActions.FetchUsersByCompanyId(companyId));
  }

  getUsersByCompanyId$(id: string): Observable<any> {

    const usersCollection = this.db.collection<any>('users', ref => ref
      .where('companyId', '==', id)
    );

    return usersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }
  getUsersBySiteId$(id: string, limit?: number): Observable<any> {

    if (id === null){return of([])} 

    let usersCollection;

    if (limit !== null) {
      usersCollection = this.db.collection<any>('users', ref => ref
        .where('siteId', '==', id)
        .limit(limit!)
      );
    } else {
      usersCollection = this.db.collection<any>('users', ref => ref
        .where('siteId', '==', id)
      );
    }

    return usersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  findUsersById(id: string): Observable<User[]> {

    return this.store.select(selectUsersById, { id });

  }

  findUsersByCompanyId(companyId: string): Observable<User[]> {

    return this.store.select(selectUsersByCompanyId, { companyId });

  }



  addUser(value: any) {
    const user = new User();
    user.id = this.generateUUID();
    user.email = value.email;
    user.photoURL = value.photoURL;
    user.displayName = value.displayName;
    user.roles = value.roles;
    user.companyId = value.companyId;

    this.store.dispatch(new UserActions.AddUser(user));

  }

  deleteUser(id: string) {
    this.store.dispatch(new UserActions.DeleteUser(id));
  }

  updateUser(user: any) {

    this.store.dispatch(
      new UserActions.UpdateUser(user)
    );
  }

  updateUser$(user: any) {

    const userRef: AngularFirestoreDocument<User> = this.db.collection('users').doc(user.id);
    const userData: any = Object.assign({}, user);
    console.log('userData.....', userData);
    return of(userRef.set(userData, { merge: true }));
  }

  updateUserFirebase$(user: any) {
    console.log('updateUserFirebase$: e', user);

    const productsRef: AngularFirestoreDocument<any> = this.db.collection('users').doc(user.uid);

    const userData: any = Object.assign({}, user);

    return productsRef.set(userData, { merge: true });
  }

  getUsers() {
    this.store.dispatch(new UserActions.FetchUsers());
  }


  generateUUID() {
    return UUID.UUID();
  }
}

